import React, {Component} from 'react';
import objeler from '../objeler';
import Colorpicker from '../Colorpicker';
import ComboBox from "./ComboBox";
import 'react-dropdown/style.css'
import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';
import './modal.css'

const fontItems = require('../../items/fontitems.json');
const barcodeTypeItems = require('../../items/BarcodeTypes.json');
const QREncodingItems = require('../../items/QREncoding.json');
const QRLevelItems = require('../../items/QRLevel.json');
const marks = [
    {
        value: 0,
        label: '0',
    },
    {
        value: 1,
        label: '1',
    },
    {
        value: 2,
        label: '2',
    },
    {
        value: 3,
        label: '3',
    },
    {
        value: 4,
        label: '4',
    },
    {
        value: 5,
        label: '5',
    },
    {
        value: 6,
        label: '6',
    },
    {
        value: 7,
        label: '7',
    },
    {
        value: 8,
        label: '8',
    },
    {
        value: 9,
        label: '9',
    },
];

class BarcodeProperties extends Component {
    options = [
        '6', '7', '8', '9'
    ];
    defaultOption = this.options[0];

    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.state = {
            activeFontFamily: "Open Sans",
            activeBold: "false",
            barcodeColor: 'black'
        };
    };

    componentDidMount() {
        this.setState({dataSourceValue: objeler.ElementProps.DataSource, barcodeColor: objeler.ElementProps.Color})
        setTimeout(() => {
            try {
                this.child.select();
            } catch {
                try {
                    this.child.focus();
                } catch {
                }
            }
        }, 1);
    }

    valuetext(value) {
        return `${value}`;
    }

    updateInputValue(e) {
        objeler.tarik.Text = e.target.value;
    }

    changeColor = (clr, event) => {
        objeler.tarik.Color = clr.hex;
        this.setState({barcodeColor: clr.hex})
    };
    changeBgColor = (clr, event) => {
        objeler.tarik.BColor = clr.hex;
    };

    onWordStateChange(e) {
        this.setState({value: e});
        objeler.ElementProps.ContentState = e;
    }

    onTypeChage(e) {
        this.setState({value: e.target.value});
        objeler.ElementProps.BarcodeType = e.target.value;
    }

    onEncodingChage(e) {
        this.setState({value: e.target.value});
        objeler.ElementProps.QREncoding = e.target.value;
    }

    onLevelChage(e) {
        this.setState({value: e.target.value});
        objeler.ElementProps.QRLevel = e.target.value;
    }

    onVersionChage(e) {
        this.setState({value: e.target.value});
        objeler.ElementProps.QRVersion = e.target.value;
    }

    onThicknessChage(e) {
        this.setState({value: e.target.value});
        objeler.ElementProps.Thickness = e.target.value;
    }

    onUnicodeChage(e) {
        this.setState({value: e.target.value});
        objeler.ElementProps.QRUnicode = e.target.value;
    }

    onFontChage(e) {
        this.setState({value: e.target.value, text: e.target[e.target.selectedIndex].text});
        objeler.tarik.Font = e.target.value;
        objeler.tarik.FontFamily = e.target[e.target.selectedIndex].text;
    }

    onChangeMline(e) {
        objeler.ElementProps.MLine = e.target.checked;
    }

    onChangeBound(e) {
        this.setState({disabledBound: !this.state.disabledBound})
        objeler.ElementProps.Bound = e.target.checked;
        if (!objeler.ElementProps.Bound)
            objeler.ElementProps.DataSource = "";
        this.setState({dataSourceValue: objeler.ElementProps.DataSource})
    }

    onChangeBold(e) {
        objeler.ElementProps.Bold = e.target.checked;
    }

    onChangeItalic(e) {
        objeler.ElementProps.Italic = e.target.checked;
    }

    onFontSizeChage(e) {
        this.setState({FontSize: e.target.value})
        objeler.tarik.FontSize = e.target.value;
        objeler.ElementProps.FontSize = e.target.value;
        console.log("objeler.ElementProps.FontSize", objeler.ElementProps.FontSize);
    }

    render() {
        const fontStyles = {
            values: [
                {
                    name: 'Regular',
                    value: 'Regular',
                },
                {
                    name: 'Bold',
                    value: 'Bold',
                },
                {
                    name: 'Italic',
                    value: 'Italic',
                },
                {
                    name: 'Bold Italic',
                    value: 'BoldItalic',
                },
            ],
            value: '?',
        };
        const {t, color, backgroundColor, type, properties} = this.props;
        const prp = objeler["tarik"];
        const fontSizeStyle = {
            width: "60px",
            textAlign: 'center',
            height: "23px",
            borderWidth: "1px",
            textAlignVertical: "middle",
            marginTop: "0px",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const trStyle = {
            borderWidth: "1px",
        };
        const tdStyle = {
            color: "Black",
            textAlign: "left",
            valign: "bottom"
            , overflow: 'hidden'
        };
        const pStyle = {
            fontSize: "14px",
            height: "16px",
            width: "90px",
            color: "#000000",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const lStyle = {
            fontSize: "14px",
            height: "16px",
            width: "65px",
            color: "#000000",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const p2Style = {
            fontSize: "14px",
            height: "16px",
            width: "40px",
            color: "#000000",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const tableStyle = {
            left: "47px",
            width: "535px",
            height: "208px",
            zIndex: "6"
            , overflow: 'hidden'
        };
        const textStyle = {
            display: "block",
            width: "100%",
            height: "25px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const dataSourceStyle = {
            display: "block",
            marginLeft: 0,
            width: "150px",
            height: "25px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const formatStyle = {
            display: "block",
            marginLeft: 0,
            width: "100px",
            height: "25px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const comboStyle = {
            display: "block",
            height: "25px",
            zIndex: "0",
            vAlign: "middle",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        return (
            <div>
                {(() => {
                    switch (objeler.ElementProps.BarcodeType) {
                        case "QR":
                        case "EAN128":
                        case "I25":
                            return (
                                <React.Fragment>
                                    <table style={tableStyle} id="Table1">
                                        <tr style={{border: '0px'}}>
                                            <td class="cell0"><p style={pStyle}>&nbsp;Text : </p></td>
                                            <td class="cell1" style={{width: '400%'}}>
                        <textarea name="TextArea1" id="TextArea1"
                                  ref={abc => this.child = abc}
                                  defaultValue={objeler.ElementProps.Text}
                                  onChange={this.updateInputValue}
                                  style={textStyle} rows="1" cols="20" spellCheck="false">
                        </textarea>
                                            </td>
                                            <td class="cell0"><p style={pStyle}>&nbsp;Data Source</p></td>
                                            <td class="cell1" style={{width: '200px'}, {border: '0px',}}>
                                                <div style={{display: 'flex'}}>
                                                    <textarea name="TextArea1" id="TextArea1"
                                                              defaultValue={this.state.dataSourceValue}
                                                              onChange={e => objeler.ElementProps.DataSource = e.target.value}
                                                              disabled={(!this.state.disabledBound) ? "disabled" : ""}
                                                              style={dataSourceStyle} rows="1" cols="20"
                                                              spellCheck="false">
                          </textarea>
                                                    <div id="wb_Checkbox1">
                                                        <input type="checkbox" id="chkBound" name=""
                                                               style={{display: "inline-block"}}
                                                               onChange={e => this.onChangeBound(e)}
                                                               defaultChecked={objeler.ElementProps.Bound}/>
                                                        <label for="Checkbox1"
                                                               style={{left: "60px"}, {float: "right"}, {position: "absolute"}, {fontWeight: "bold"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bound</label>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="cell0"><p style={pStyle}>Color:</p></td>
                                            <td class="cell1" colSpan="2">
                                                <table>
                                                    <tr style={{border: '0px'}}>
                                                        <td style={{width: '7%'}, {border: '0px'}}>
                                                            <Colorpicker color={prp.Object.properties.colors.color}
                                                                         onChangeCompleted={this.changeColor}
                                                                         style={{zIndex: '100'}}
                                                            />
                                                        </td>
                                                        <td style={{width: '100px'}}/>
                                                        <p style={lStyle}>Thickness</p>
                                                    </tr>
                                                </table>
                                            </td>
                                            <td class="cell0">
                                                <div>
                                                    <Box sx={{width: 300}}>
                                                        <Slider
                                                            defaultValue={objeler.ElementProps.Thickness}
                                                            step={1}
                                                            valueLabelDisplay="auto"
                                                            onChange={e => this.onThicknessChage(e)}
                                                            marks
                                                            max={9}
                                                            min={0}
                                                            size={'small'}
                                                            style={{width: '140px'}}
                                                        />
                                                    </Box>
                                                </div>
                                            </td>
                                            <td class="cell1">
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="cell0"><p style={pStyle}>Type: </p></td>
                                            <td class="cell1" colSpan="2"><ComboBox onChange={e => this.onTypeChage(e)}
                                                                                    comboStyle={comboStyle}
                                                                                    comboValue={objeler.ElementProps.BarcodeType}
                                                                                    items={barcodeTypeItems}/></td>
                                            <td style={{minWidth: '300px', display: 'flex', justifyContent: 'center'}}>
                                                <div style={{
                                                    maxWidth: objeler.ElementProps.BarcodeType == 'QR' ? '100px' : '400px',
                                                    position: 'absolute'
                                                }}>
                                                    <img
                                                        src={objeler.ElementProps.BarcodeType == 'QR' ? 'images/qr_TR.gif' : objeler.ElementProps.BarcodeType == 'EAN128' ? 'images/code128l_TR.gif' : 'images/i25l_TR.gif'}
                                                        style={{backgroundColor: this.state.barcodeColor}}
                                                    ></img>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style={{visibility: objeler.ElementProps.BarcodeType == 'QR' ? 'visible' : 'hidden'}}>
                                            <td class="cell0"><p style={pStyle}>Encoding: </p></td>
                                            <td class="cell1">
                                                <ComboBox onChange={e => this.onEncodingChage(e)}
                                                          comboStyle={comboStyle}
                                                          comboValue={objeler.ElementProps.QREncoding}
                                                          items={QREncodingItems}/>
                                            </td>
                                        </tr>
                                        <tr style={{visibility: objeler.ElementProps.BarcodeType == 'QR' ? 'visible' : 'hidden'}}>
                                            <td class="cell0"><p style={pStyle}>Corrention: </p></td>
                                            <td class="cell1">
                                                <ComboBox onChange={e => this.onLevelChage(e)} comboStyle={comboStyle}
                                                          comboValue={objeler.ElementProps.QRLevel}
                                                          items={QRLevelItems}/>
                                            </td>
                                        </tr>
                                        <tr style={{visibility: objeler.ElementProps.BarcodeType == 'QR' ? 'visible' : 'hidden'}}>
                                            <td class="cell0"><p style={pStyle}>Version: </p></td>
                                            <td class="cell1">
                                                <input name="TextArea1" id="TextArea1"
                                                       type="number"
                                                       onKeyDown={e => e.preventDefault()}
                                                       min="1" max="40" style={fontSizeStyle}
                                                       onChange={e => this.onVersionChage(e)}
                                                       value={objeler.ElementProps.QRVersion}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                        </tr>
                                    </table>
                                </React.Fragment>
                            );
                    }
                }).call(this)}
            </div>
        );
    }
}

export default BarcodeProperties;